/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button } from "@mui/material";
import ContentShell from "components/ContentShell";
import { SimpleTextInput } from "components/FormTextInput";
import { useSnackbar } from "hooks/useSnackbar";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useStyles from "styles/store/storeEditor";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { getCoinOVRInfo, updateCoinOVRInfo } from "services/miscService";
import * as Yup from "yup";
import sessionHelperInstance from "services/sessionHelper";
import { PermittedRoles } from "utils/permissions";

const _sellPlayerDetails = {
  playerOvr: 0,
  sellPrice: 0,
};

const sellPlayerValidation = Yup.array().of(
  Yup.object().shape({
    playerOvr: Yup.number()
      .min(50, ({ path }) => {
        let item = parseInt(path.match(/\d+/)[0], 10) + 1;
        return `Item ${item} Player OVR must be greater than or equal to 50`;
      })
      .required("Player OVR is requied."),
    sellPrice: Yup.number()
      .min(0, ({ path }) => {
        let item = parseInt(path.match(/\d+/)[0], 10) + 1;
        return `Item ${item} Sell Price must be greater than or equal to 0`;
      })
      .required("Sell Price is requied."),
  })
);

const SellPlayerEditor = () => {
  const styles = useStyles();
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [sellPlayersDetails, setSellPlayersDetails] = useState([
    _sellPlayerDetails,
  ]);
  const hasDeletePermission = sessionHelperInstance.hasRole(
    PermittedRoles.SELL_PLAYER.DELETE_ROLES
  );

  const submit = async () => {
    setLoading(true);
    try {
      await sellPlayerValidation.validate(sellPlayersDetails);

      let payload = sellPlayersDetails.reduce((acc, curr) => {
        const { playerOvr, sellPrice } = curr;
        acc[`${playerOvr}`] = parseInt(String(sellPrice));
        return acc;
      }, {});

      const resp = await updateCoinOVRInfo({ ovrTwoCoinValues: payload });

      setLoading(false);
      showSnackbar(resp?.message ?? "Store updated successfully");
    } catch (error) {
      setLoading(false);
      showSnackbar(error?.message, "error");
    }
  };

  const onChange = (e, index) => {
    const { name, value } = e.target;

    setSellPlayersDetails((st) => [
      ...st.slice(0, index),
      {
        ...st[index],
        [name]: value,
      },
      ...st.slice(index + 1),
    ]);
  };

  const removeItem = (index, sellPlayer) => {
    const lastestState = [...sellPlayersDetails];
    lastestState.splice(index, 1);

    setSellPlayersDetails(lastestState);
  };

  const info = async () => {
    try {
      setLoading(true);
      const response = await getCoinOVRInfo();
      const data = Object.entries(response.data.ovrTwoCoinValues).reduce(
        (acc, [playerOvr, sellPrice]) => {
          acc.push({ playerOvr, sellPrice });
          return acc;
        },
        []
      );
      setSellPlayersDetails(data.reverse());
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showSnackbar(error?.message, "error");
    }
  };

  const addItem = () =>
    setSellPlayersDetails((st) => {
      return [_sellPlayerDetails, ...st];
    });

  useEffect(() => {
    info();
  }, []);

  return (
    <ContentShell
      showBackButton
      onBackButtonClick={() => navigate(-1)}
      title={`Sell Player`}
      loading={loading}
      actions={
        <Box style={{ display: "flex", gap: 5 }}>
          <Button type="submit" variant="contained" onClick={addItem}>
            Add a Row
          </Button>
          <Button type="submit" variant="contained" onClick={submit}>
            Save
          </Button>
        </Box>
      }
    >
      <Box>
        <Box className={styles.container}>
          <Box style={{ display: "flex", flexFlow: "row wrap", gap: 10 }}>
            <Box>
              {sellPlayersDetails.map((sellPlayer, index) => {
                return (
                  <Box
                    key={index}
                    style={{
                      display: "flex",
                      flexFlow: "row wrap",
                      gap: 5,
                    }}
                  >
                    <Box className={styles.field}>
                      <SimpleTextInput
                        type="number"
                        name="playerOvr"
                        label="Player OVR"
                        onChange={(e) => onChange(e, index)}
                        value={sellPlayer.playerOvr}
                      />
                    </Box>
                    <Box className={styles.field}>
                      <SimpleTextInput
                        type="number"
                        name="sellPrice"
                        label="Sell Price"
                        onChange={(e) => onChange(e, index)}
                        value={sellPlayer.sellPrice}
                      />
                    </Box>

                    {hasDeletePermission && (
                      <Button
                        style={{
                          height: 30,
                          marginTop: 28,
                          backgroundColor: "red",
                        }}
                        onClick={() => removeItem(index, sellPlayer)}
                      >
                        <DeleteForeverIcon style={{ color: "white" }} />
                      </Button>
                    )}
                  </Box>
                );
              })}
            </Box>
          </Box>
        </Box>
      </Box>
    </ContentShell>
  );
};

export default SellPlayerEditor;
